export const nlCategorySlugToEn = {
  'verzending-en-levering': 'shipping-and-delivery',
  'horloge-service': 'watch-service',
  'juwelen-service': 'jewel-service',
  betalen: 'payments',
  vestigingen: 'stores',
  'retour-en-terugbetaling': 'return-and-refund',
}

export const nlToCategoryCodeName = {
  'verzending-en-levering': 'shipping_delivery_questions',
  'horloge-service': 'watch_service_questions',
  'juwelen-service': 'jewel_service_questions',
  betalen: 'pay_questions',
  vestigingen: 'stores_questions',
  'retour-en-terugbetaling': 'return_refund_questions',
}

export const enToCategoryCodename = {
  'shipping-and-delivery': 'shipping_delivery_questions',
  payments: 'pay_questions',
  'return-and-refund': 'return_refund_questions',
  stores: 'stores_questions',
  'watch-service': 'watch_service_questions',
  'jewel-service': 'jewel_service_questions',
}
